<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-content>
        <p>To allow the devices and applications to access supporting cloud services, associated IP address must be
          whitelisted. Update the IP address you wish to whitelist.</p>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          {{lastServerError || 'Error occurred'}}
        </div>

        <div class="alert alert-info" *ngIf="firewallLimits > 0">
          Your Current Public IP Address is <b style="cursor: pointer" title="Click IP Address to prefill form"
                                               (click)="copyIpAddress()">{{clientIpAddress}}</b>
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="firewallLimits <= 0">
          You've reached the limit for IP Addresses whitelist, please contact <a href="mailto:support@telego.com">support&#64;telego.com</a>
          to increase your limit or click the button "Request More" below.
        </div>

        <app-mat-text-input *ngIf="firewallLimits > 0" [formControl]="ipAddressControl"
                            label="IP Address" name="ipAddress" placeholder="xxx.xxx.xxx.xxx"
                            [submitted]="submitted"></app-mat-text-input>

        <app-mat-multiselect [formControl]="customerNoteControl"
                             placeholder="type to search"
                             label="Which agents or groups is this for?"
                             name="notes"
                             [submitted]="submitted"
                             [allowCustomValue]="false"
                             [autoCompleteValues]="availablePbxAccounts"
        ></app-mat-multiselect>
        <app-mat-textarea-input [formControl]="additionalNotesControl"
                                label="Notes"
                                name="additionalNotes"
                                [submitted]="submitted">

        </app-mat-textarea-input>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="firewallLimits > 0"
             style="margin-bottom: 1em">
          <app-mat-date-input [formControl]="startOnControl" fxFlex
                              label="Valid From" name="startOn"
                              (valueChanged)="onStartDateChange($event)"
                              [submitted]="submitted"></app-mat-date-input>
          <app-mat-date-input [formControl]="endOnControl" fxFlex
                              label="Valid Until" name="endOn"
                              [submitted]="submitted"
                              [customErrors]="{maxDateRange: 'Date range must be less than 365 days', greaterThenStart: 'Must be greater than start date'}"
          ></app-mat-date-input>
        </div>


        <app-mat-checkbox-input *ngIf="firewallLimits > 0" [formControl]="notifyExpirationControl"
                                style="margin-top: 1em;"
                                (ngModelChange)="notifyExpirationChanged($event)"
                                label="Notify before expiration" name="notifyExpiration"
                                [submitted]="submitted"></app-mat-checkbox-input>

        <app-mat-multiselect [formControl]="recipientsControl" *ngIf="firewallLimits > 0"
                             placeholder="Enter email addresses"
                             label="Recipients"
                             [submitted]="submitted"
                             validator="mail"
        ></app-mat-multiselect>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button type="submit" mat-raised-button color="primary" matTooltip="Save changes" [promiseBtn]="buttonSubmitPromise"
                *ngIf="hasEditAccess">
          {{firewallLimits > 0 ? 'Save' : 'Request More'}}
        </button>
        <button type="button" mat-raised-button color="warn" class="only-icon" matTooltip="Remove IP Address" (click)="onDeleteClick()"
                *ngIf="hasDeleteAccess && editModel.id && editModel.id !== 'new'">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
